var body = 'fx_2d2fb1e5_1cr9mb0';

export { body };
//# sourceMappingURL=body.vanilla.mjs.map
